import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
//import { ApiLoginService } from './api-login.service';

@Injectable({
  providedIn: 'root'
})
 
export class ApiService {

	// private urlApi = 'http://localhost:8000/';
  // public urlApi = 'http://coremanagement-dev.mncplaymedia.com/core-backend/public/';
  // public urlApi = 'http://localhost/sgsbackend/frontend/web/index.php/';
  // public urlApi = 'http://localhost/apiopencontent/frontend/web/index.php/'; 
  // public urlApivalsys = 'http://localhost/valsys/frontend/web/index.php/';
  // public urlApi = 'http://10.9.26.169/sgsapi/frontend/web/index.php/';
  // public urlApi = 'http://sgs-api-dev.mncplaymedia.com/frontend/web/index.php/';
   public urlApi = 'http://localhost/sgsapi/frontend/web/index.php/';
 // public urlApi = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/'; //dev_public
  // public urlApi = 'https://sgs-api.mncplay.id/frontend/web/index.php/'; //prod_public
  public urlApiImage = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/';

  // public urlApilocation = "https://eu1.locationiq.com/v1/search.php?key=1d5dbcfc514ea6&format=json"

  constructor(
    private http: HttpClient,
    
  ) { }

  _httpOptions(){
    
    
      return {
            headers: new HttpHeaders({
              'Authorization': 'Bearer yjZTLzwcoRzZYl809HLVdKTWc_K2ZV2y',
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    
  } 
  
  _httpOptionsparams(params:any){
    
    const currentUser:any = JSON.parse(localStorage.getItem('currentUser'));;
    // console.log(currentUser);
    const isLoggedIn:any = currentUser && currentUser.data.access_token;
    // console.log(isLoggedIn);
  
    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+currentUser.data.access_token,
              'referer-policy': 'no-referrer-when-downgrade'
            }),
            params: params
          };
    }else{
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  } 

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  
  /* start test Api */
  // setCreateporspect(params: any){
  //     // console.log( JSON.stringify(getFormEditCategory));
  //     return this.http.post<any>(this.urlApivalsys + 'valsys/entryprospects/createprospect', (params), this._httpOptions());
  // }

  searchCustomer(data: any){
    return this.http.post<any>(this.urlApi + 'purchase/actions/search', JSON.stringify(data), this._httpOptions() );
  }

  getAlacarte(data:any){
    return this.http.post<any>(this.urlApi + 'purchase/actions/productaddon', JSON.stringify(data), this._httpOptions() );
  }

  Calculate(data:any){
    return this.http.post<any>(this.urlApi + 'purchase/actions/calculate', JSON.stringify(data), this._httpOptions() );
  }

}
